
export interface CoreSkola24ScheduleConfiguration {
    id: string
    hostname?: string
    importIntervalRule: Skola24ScheduleImportIntervalRule
    eventNaming: CoreSkola24EventNaming,
    eventFilters: CoreSkola24EventFilter[]
    organizationExport: CoreSkola24ScheduleOrganizationExportConfiguration
    requireOrganizer: boolean
}

export interface CoreSkola24EventFilter {
    filterType: Skola24EventFilterType 
    filterField: Skola24EventFilterField
    value: string
}

export enum Skola24EventFilterType {
    None = 0,
    Exact = 1,
    StartsWith = 2,
    EndsWith = 3,
    Contains = 4,
}

export enum Skola24EventFilterField {
    None = 0,
    Subject = 1,
    Course = 2,
    CourseAndSubject = 3,
};


export enum Skola24ScheduleImportIntervalRule {
    Undefined = 0,
    UpcomingMonth = 1,
    Upcoming3Months = 2,
    Upcoming6Months = 3,
    CurrentSemester = 4,
    CurrentSchoolYear = 5
}

export enum CoreSkola24EventNaming {
    Undefined = 0,

    /// <summary>
    /// EventName = "Svenska"
    /// </summary>
    CourseSubject = 1,

    /// <summary>
    /// EventName = "7A"
    /// </summary>
    Group = 2,

    /// <summary>
    /// EventName = "7A (Svenska)"
    /// </summary>
    GroupWithCourseSubject = 3,

    /// <summary>
    /// EventName = "Svenska (7A)"
    /// </summary>
    CourseSubjectWithGroup = 4,
}

export interface CoreSkola24ScheduleOrganizationExportConfiguration {
    enabled: boolean,
    domainNameFilter: string[],
}